import React from 'react';
import "./aboutUs.css";

// import {PartnersSingle} from "../../components"
//import {PartnersSingleLine} from "../../components"
// import {Member} from "../../components"
// import {MemberMob} from "../../components"


const AboutUs = () => {
  return (
    <section id='about'>
     
        <div className='container aboutus-container'>
          <div className='row about-section-main'>
                 <div className='col-lg-6 col-md-6 col-sm-12 about-main-title'>
                    <h2 className='about-section-title'>About</h2>
                </div>
            </div> 
           
           <div className='row aboutus-text-main'>  

             <div className='col-lg-8 col-md-12 col-sm-12 aboutus-text-right'>

               
                <div className='aboutus-col'>
                
                 <p>Our vision is a affordable, lightning-fast, and quantum-resistant digital future that guarantees ultimate security across Web3 and enterprise digital infrastructure.</p>

                
            </div>
            <div className='aboutus-col'>
                    
                <p>Our mission is to deliver high-performance cryptographic processors built on our silicon-proven hardware IP. We focus on the compute-intensive primitives at the heart of modern confidential, verifable and secure computing, specifically those powering ZKPs, FHE, with the transition to Post-Quantum Cryptography. By mastering these core building blocks, we enable the throughput and efficiency required for the future of decentralized and enterprise infrastructure.</p>

              
             </div>

              
             <div className='aboutus-col'>
                   
                   
                    <p>We are committed to building the "NVIDIA of modern cryptography." By bridging the gap between complex mathematical schemes and efficient hardware, our goal is to provide the foundational compute platform for a secure, scalable, and sustainable post-quantum era.</p>

                    

               </div>

             {/* <PartnersSingleLine/> 
             <PartnersSingle/> */}
             {/* <Member/>
             <MemberMob/> */}
             
           </div>

             
              
            </div>

            
        </div>

       
    </section>
  )
}

export default AboutUs
